import { render, staticRenderFns } from "./WelfareCentreNatureEmployeesNumber.vue?vue&type=template&id=0afe119e&scoped=true&"
import script from "./WelfareCentreNatureEmployeesNumber.vue?vue&type=script&lang=js&"
export * from "./WelfareCentreNatureEmployeesNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afe119e",
  null
  
)

export default component.exports